import React from 'react';
import HelpApiLayout from '../../../../components/layout/HelpApiLayout';
import HelpSidebar from '../../../../components/layout/HelpSidebar';
import SimpleCard from '../../components/SimpleCard';
import LastUpdated from '../../../../components/layout/docs/LastUpdated';
import { getHelpArticleRoute } from '../../../../constants/routes';
import { getHelpRoute } from '../../../../utils/navigation';
import '../../HelpCenter.css';

/**
 * Features Category Page
 */
const Features = () => {
  const cards = [
    {
      title: 'Link Cards & Wallets',
      description: 'Learn how to link your cards and wallets to your WeSplit account.',
      route: getHelpRoute(getHelpArticleRoute('features', 'link-cards-wallets'))
    },
    {
      title: 'Your Profile',
      description: 'Customize your profile settings and preferences.',
      route: getHelpRoute(getHelpArticleRoute('features', 'your-profile'))
    },
    {
      title: 'Badge Community',
      description: 'Discover and earn community badges.',
      route: getHelpRoute(getHelpArticleRoute('features', 'badge-community'))
    },
    {
      title: 'Send (P2P)',
      description: 'Send payments directly to other users.',
      route: getHelpRoute(getHelpArticleRoute('features', 'send-p2p'))
    },
    {
      title: 'Request (P2P)',
      description: 'Request payments from other users.',
      route: getHelpRoute(getHelpArticleRoute('features', 'request-p2p'))
    },
    {
      title: 'Gas Fees',
      description: 'Understand how gas fees work on WeSplit.',
      route: getHelpRoute(getHelpArticleRoute('features', 'gas-fees'))
    },
    {
      title: 'Rewards',
      description: 'Learn about rewards and how to earn them.',
      route: getHelpRoute(getHelpArticleRoute('features', 'rewards'))
    },
    {
      title: 'Groups',
      description: 'Create and manage groups for shared expenses.',
      route: getHelpRoute(getHelpArticleRoute('features', 'groups'))
    }
  ];

  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-center">
        <div className="help-center-container">
          <header className="lp-section-header">
            <h1 className="lp-section-title">Features</h1>
            <p className="lp-section-subtitle">
              Learn about splitting methods, currencies, and expense tracking.
            </p>
          </header>

          <section className="help-center-categories">
            <div className="help-center-cards">
              {cards.map((card, index) => (
                <SimpleCard
                  key={index}
                  title={card.title}
                  description={card.description}
                  route={card.route}
                />
              ))}
            </div>
          </section>

          <LastUpdated />
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default Features;
